import { render, staticRenderFns } from "./FirmsTable.vue?vue&type=template&id=074c8279&scoped=true&"
import script from "./FirmsTable.vue?vue&type=script&lang=js&"
export * from "./FirmsTable.vue?vue&type=script&lang=js&"
import style0 from "./FirmsTable.vue?vue&type=style&index=0&id=074c8279&prod&lang=scss&scoped=true&"
import style1 from "./FirmsTable.vue?vue&type=style&index=1&id=074c8279&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c8279",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
